import { Grid, Typography } from '@mui/material';
import { Box } from '@mui/system';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { IStyles, pxToRem, pxTovW } from '@geneo2-web/shared-ui';
import {
  useAppDispatch,
  useAppSelector,
} from '../../../../../reduxStore/reduxHooks';
import { setFASelectedChapterData } from '../../../reducer/assessmentFlow.slice';
import { SubjectChapterMiniInfo } from '@protos/content_management/content.common.apis_pb';
import { FAChapterSelectionCard } from './FAChapterSelectionCard';
import { EditWarningPopup } from '../../../../../components/EditWarningPopup';
import { useState } from 'react';
import { setToastInfo } from '../../../../../pages/Home/reducer/homeDashboard.slice';
import { interactionEvent } from '../../../../Auth/auth.events';
import { useLocation } from 'react-router-dom';
import { useDownloadContext } from '../../../../../app/Context/DownloadContextProviderV2';

const styles: IStyles = {
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    // backgroundColor: 'red',
  },
};
interface IProps {
  addMoreHandler: () => void;
  chapterEditHandler: (chapter: SubjectChapterMiniInfo) => void;
  setStep: (step: 'chapterSelection' | 'settings' | undefined) => void;
  selectedChapterList: SubjectChapterMiniInfo[];
  setSelectedChapterList: (chapterList: SubjectChapterMiniInfo[]) => void;
}
export const ChapterSelection = (props: IProps) => {
  const {
    addMoreHandler,
    chapterEditHandler,
    setStep,
    selectedChapterList,
    setSelectedChapterList,
  } = props;

  const dispatch = useAppDispatch();
  const location = useLocation();
  const pathSegments = location.pathname.split('/');
  const { isOffline } = useDownloadContext();
  const { fa_selected_chapter_data } = useAppSelector(
    (state) => state.assessment
  );
  const [chapterToDelete, setChapterToDelete] = useState<
    SubjectChapterMiniInfo | undefined
  >();
  const [openDeletePopup, setOpenDeletePopup] = useState(false);
  const deleteChapterHandler = (chapterInfo: SubjectChapterMiniInfo) => {
    // console.log('deleteChapterHandler', chapterInfo);
    if (!fa_selected_chapter_data) return;

    const updatedChapters = (fa_selected_chapter_data.chapters || []).filter(
      (ch) => ch.chapterId !== chapterInfo.chapterId
    );
    if (updatedChapters.length === 0) {
      setStep(undefined);
    }
    setSelectedChapterList([...updatedChapters]);
    dispatch(
      setFASelectedChapterData({
        ...fa_selected_chapter_data,
        chapters: updatedChapters,
      })
    );
  };
  return (
    <Box sx={styles.root}>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          mt: { xs: pxToRem(32), md: pxTovW(20) },
        }}
      >
        <Typography variant="h2" sx={{ marginY: 'auto' }}>
          Your Added Chapters
        </Typography>
        <Box
          sx={{
            backgroundColor: 'transparent',
            background: '#C1F8DA',
            display: 'flex',
            borderRadius: { xs: pxToRem(6), md: pxTovW(10) },
            boxSizing: 'border-box',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            border: '1px solid #0AA34F',
            padding: {
              xs: pxToRem(7),
              md: `${pxTovW(16)} ${pxTovW(23)}`,
              lg: `${pxTovW(13)} ${pxTovW(25)}`,
            },
            gap: { xs: pxToRem(5), md: pxTovW(16) },
            height: { xs: pxToRem(32), md: pxTovW(57) },
          }}
          onClick={addMoreHandler}
        >
          <AddCircleIcon
            sx={{
              color: '#03612D',
              fontSize: { xs: pxToRem(18), md: pxTovW(31) },
            }}
          />
          <Typography variant="h3" fontWeight="bold" sx={{ color: '#0AA34F' }}>
            Add More
          </Typography>
        </Box>
      </Box>
      <Box sx={{ mt: { xs: pxToRem(12), md: pxTovW(20) }, width: '100%' }}>
        <Grid
          container
          columns={12}
          rowGap={3}
          sx={{ padding: 0, width: '100%' }}
        >
          {' '}
          {fa_selected_chapter_data?.chapters?.map((chapter, index) => (
            <Grid item md={4} xs={12} key={index}>
              <Box
                key={index}
                sx={{
                  boxSizing: 'border-box',
                  width: '100%',
                  paddingX: { xs: pxToRem(10), md: pxTovW(10) },
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <FAChapterSelectionCard
                  selected
                  chapterInfo={chapter}
                  selectedChapterList={selectedChapterList}
                  deleteHandler={() => {
                    setChapterToDelete(chapter);
                    setOpenDeletePopup(true);
                  }}
                  chapterEditHandler={chapterEditHandler}
                  variant="medium"
                />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
      <EditWarningPopup
        open={openDeletePopup}
        handleClose={() => setOpenDeletePopup(false)}
        yesClickHandler={async () => {
          chapterToDelete && deleteChapterHandler(chapterToDelete);
          setOpenDeletePopup(false);
          dispatch(
            setToastInfo({
              label: `${chapterToDelete?.chapterTitle} deleted successfully`,
              variant: 'info',
              open: true,
            })
          );
          await interactionEvent({
            url: 'Teacher_formative_assessment_create',
            context: 'chapter_delete',
            name: 'YES',
            pathSegments: pathSegments,
            isOffline: isOffline,
          });
        }}
        noClickHandler={async () => {
          setOpenDeletePopup(false);
          await interactionEvent({
            url: 'Teacher_formative_assessment_create',
            context: 'chapter_delete',
            name: 'NO',
            pathSegments: pathSegments,
            isOffline: isOffline,
          });
        }}
        iconname="delete"
        text1={`Are you sure to you want to delete ${chapterToDelete?.chapterTitle} ?`}
        text2=""
      />
    </Box>
  );
};
